// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"84a4215b","990":"aa69e0b4"}[chunkId] + ".chunk.css";
};